import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Services from "@/components/Services";
import Process from "@/components/Process";
import Pricing from "@/components/Pricing";
import CaseStudy from "@/components/CaseStudy";
import Testimonials from "@/components/Testimonials";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import ChatWidget from "@/components/ChatWidget";
import WhatsAppButton from "@/components/WhatsAppButton";
import AdminGuard from "@/components/AdminGuard";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

import { AuthProvider } from "@/lib/AuthContext";
import { CalendlyProvider } from "@/lib/CalendlyContext";

const OnePager = () => (
  <div className="App relative bg-[#faf7ee] text-[#0a0a0a]" data-testid="page-root">
    <Navbar />
    <main>
      <Hero />
      <Process />
      <Services />
      <Pricing />
      <CaseStudy />
      <Testimonials />
      <Contact />
      <About />
    </main>
    <Footer />
    <ChatWidget />
    <WhatsAppButton />
  </div>
);

const ToastConfig = () => (
  <Toaster
    theme="light"
    position="bottom-center"
    toastOptions={{
      style: {
        background: "#ffffff",
        border: "1px solid rgba(184,144,31,0.4)",
        color: "#0a0a0a",
        boxShadow: "0 16px 40px -16px rgba(0,0,0,0.18)",
      },
    }}
  />
);

function App() {
  return (
    <AuthProvider>
      <CalendlyProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<OnePager />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <AdminGuard>
                  <AdminDashboard />
                </AdminGuard>
              }
            />
          </Routes>
          <ToastConfig />
        </BrowserRouter>
      </CalendlyProvider>
    </AuthProvider>
  );
}

export default App;
